import { Loader2 } from "lucide-react";

export function LoadingScreen() {
	return (
		<div
			role="status"
			aria-live="polite"
			className="flex min-h-svh flex-col items-center justify-center gap-3 bg-background"
		>
			<Loader2 className="size-5 animate-spin text-brand" aria-hidden="true" />
			<span className="font-mono text-sm uppercase tracking-[0.14em] text-muted-foreground">
				&gt; Loading
			</span>
		</div>
	);
}
